<template>
  <form class="reset">
    <h1 class="reset-title">Forgot password?</h1>
    <p class="reset-subtitle">
      Enter your account email and we’ll send you instructions to reset your
      password
    </p>
    <v-text-field
        v-model="email"
        :error-messages="emailErrors"
        label="Email"
        placeholder="Enter email"
        required
        @input="$v.email.$touch()"
        @blur="$v.email.$touch()"
    ></v-text-field>
    <div class="btn-holder">
      <v-btn
          type="submit"
          :disabled="isValid"
          class="btn-success"
          @click="submit"
      >send
      </v-btn
      >
    </div>
    <div class="mt-4">
      <button class="green--text d-flex mr-auto ml-auto" @click="toLogin">
        <svg
            class="mt-1 mr-2"
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M6.40025 1.05787L0.818192 6.26191C0.716554 6.3609 0.636881 6.47762 0.583746 6.60538C0.472085 6.85878 0.472085 7.143 0.583746 7.3964C0.636881 7.52416 0.716554 7.64088 0.818192 7.73986L6.40025 12.9439C6.50434 13.041 6.62791 13.1179 6.76392 13.1704C6.89992 13.223 7.04569 13.25 7.1929 13.25C7.4902 13.25 7.77533 13.1399 7.98555 12.9439C8.19578 12.7479 8.31388 12.4821 8.31388 12.2049C8.31388 11.9278 8.19578 11.6619 7.98555 11.466L4.30139 8.0417H14.3836C14.6797 8.0417 14.9636 7.93204 15.173 7.73685C15.3824 7.54166 15.5 7.27693 15.5 7.00089C15.5 6.72485 15.3824 6.46011 15.173 6.26493C14.9636 6.06974 14.6797 5.96008 14.3836 5.96008L4.30139 5.96008L7.98555 2.53582C8.09019 2.43906 8.17324 2.32395 8.22992 2.19711C8.2866 2.07028 8.31578 1.93424 8.31578 1.79684C8.31578 1.65944 8.2866 1.52341 8.22992 1.39657C8.17324 1.26974 8.09019 1.15463 7.98555 1.05787C7.88177 0.960317 7.75829 0.882884 7.62224 0.830044C7.4862 0.777204 7.34028 0.75 7.1929 0.75C7.04552 0.75 6.8996 0.777204 6.76355 0.830044C6.62751 0.882884 6.50403 0.960317 6.40025 1.05787Z"
              fill="#19BC38"
          />
        </svg>

        <span>Back to Log in</span>
      </button>
    </div>
  </form>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
	mixins: [ validationMixin ],
	validations: {
		email: { required, email },
	},
	data() {
		return {
			email: "",
		};
	},
	computed: {
		emailErrors() {
			const errors = [];
			if (!this.$v.email.$dirty) return errors;
			!this.$v.email.email && errors.push("Must be valid e-mail");
			!this.$v.email.required && errors.push("E-mail is required");
			return errors;
		},
		isValid() {
			return !!this.emailErrors[0] === false && !!this.email === true
				? false
				: true;
		},
	},
	methods: {
		toLogin() {
			this.$emit("to-login");
		},
		async submit(e) {
			e.preventDefault();
			this.$store.dispatch("actionPreloader", true);
			await this.$store.dispatch("sendMessageReset", { email: this.email })
				.then((value) => {
					this.$store.dispatch("actionPreloader", false);
					if (value.status === false) {
						this.$store.dispatch("setAlert", {
							type: "error",
							message: value.error.email[0],
						});
					} else {
						this.$store.dispatch("setAlert", {
							type: "success",
							message:
                    "We just emailed you with instructions to reset your password. Please check your email.",
						});
						this.$emit("to-login");
					}
				});
		},
	},
};
</script>
<style lang="scss" scoped>
@import "./refresh-pass.component";
</style>
